export const slotsQueryObjectHelper = (
  action: string,
  page: number = 1,
  provider?: number,
  name?: string
) => {
  let object: {
    [key: string]: boolean | number | string | undefined;
    page: number;
    provider: number | undefined;
  };
  switch (action) {
    case "popular": {
      object = {
        popular: true,
        page,
        category: "Slots",
        provider,
      };
      break;
    }
    case "popular_live": {
      object = {
        popular: true,
        page,
        category: "Live Games",
        provider,
      };
      break;
    }
    case "popular_crash": {
      object = {
        popular: true,
        page,
        category: "Crash Games",
        provider,
      };
      break;
    }
    case "recommended": {
      object = {
        recommended: true,
        category: "Slots",
        page,
        provider,
      };
      break;
    }
    case "live": {
      object = {
        category: "Live Games",
        page,
        provider,
        name,
      };
      break;
    }
    case "crash_games": {
      object = {
        category: "Instant Win",
        page,
        provider,
        name,
      };
      break;
    }
    case "roulette": {
      object = {
        category: "Roulette",
        page,
        provider,
      };
      break;
    }
    case "card_games": {
      object = {
        category: "Card Games",
        page,
        provider,
      };
      break;
    }
    case "jackpots": {
      object = {
        category: "Jackpot",
        page,
        provider,
      };
      break;
    }
    case "mega_ways": {
      object = {
        category: "MegaWays",
        page,
        provider,
      };
      break;
    }
    case "animals": {
      object = {
        animals: true,
        category: "Slots",
        page,
        provider,
      };
      break;
    }
    case "bonus_buy": {
      object = { category: "Bonus Buy", page, provider };
      break;
    }
    case "fruits": {
      object = { fruits: true, category: "Slots", page, provider };
      break;
    }
    case "new": {
      object = {
        new: true,
        category: "Slots",
        page,
        provider,
      };
      break;
    }
    case "seven": {
      object = {
        seven: true,
        category: "Slots",
        page,
        provider,
      };
      break;
    }
    case "books": {
      object = {
        books: true,
        category: "Slots",
        page,
        provider,
      };
      break;
    }
    default: {
      object = {
        all: true,
        category: "Slots",
        page,
        provider,
        name,
      };
      break;
    }
  }
  return object;
};
